import { Routes } from '@angular/router';
import { HelpUrls } from '../../../common/dto/help-urls';

export const routes: Routes = [
  {
    path: HelpUrls._.Home.relativeUrl,
    loadComponent: () => import('./home/home.component').then(_ => _.HomeComponent),
    pathMatch: 'full',
  },
  {
    path: HelpUrls._.Articles.relativeUrl,
    loadComponent: () => import('./articles/articles.component').then(_ => _.ArticlesComponent),
  },
  {
    path: '**',
    redirectTo: HelpUrls._.Home.absoluteUrl,
  },
];
